(function() {
    'use strict';

    angular.module('swif.framework')
        .factory('dataService', dataService);

    /**
     * @ngdoc service
     * @name swif.framework.dataService
     * @requires swif.framework.settingsService
     * @requires swif.framework.msgService
     **/
    function dataService($q, $http, $location, $interval, settingsService, $localStorage, msgService,
                         swifModule, CacheService, gettextCatalog) {
        'ngInject';
        var settings = settingsService;
        var cache = {};
        var interval = {};
        var loading = {
            error: {}
        };
        var requestId = 0;

        var service = {
            countRequests: 0,
            loading: loading,
            XML_IDS: {},
            sortOn: sortOn,
            sortOnRaw: sortOnRaw,
            getSort: getSort,
            setLimit: setLimit,
            addFilter: addFilter,
            insertFilter: insertFilter,
            addExtraFilter: addExtraFilter,
            addTextExtraFilter: addTextExtraFilter,
            mergeExtraFilter: mergeExtraFilter,
            resetFilterDomain: resetFilterDomain,
            resetExtraFilter: resetExtraFilter,
            getExtraFilters: getExtraFilters,
            getFilters: getFilters,
            deleteFilter: deleteFilter,
            getFilter: getFilter,
            setFilters: setFilters,
            encodeQueryParams: encodeQueryParams,
            updateObj: updateObj,
            replaceObj: replaceObj,
            updateObjFromList: updateObjFromList,
            updateFromList: updateFromList,
            getContentTypeConfig: getContentTypeConfig,
            _getModel: _getModel,
            _getFilter: _getFilter,
            _prepareHTTPRequest: _prepareHTTPRequest,
            post: post,
            prepareOne2manyValues: prepareOne2manyValues,
            prepareImport: prepareImport,
            sanitizeData: sanitizeData,
            _prepareCollectionItems: _prepareCollectionItems,
            _get: _get,
            get: get,
            call: call,
            callKw: callKw,
            execWorkflow: execWorkflow,
            create: create,
            save: save,
            unlink: unlink,
            exportCsv: exportCsv,
            _computeSaveAsPOST: _computeSaveAsPOST,
            saveAs: _saveAs,
            exportCSV: _exportCSV,
            _computeReportPOST: _computeReportPOST,
            downloadReport: downloadReport,
            getModel: getModel,
            getFields: getFields,
            getRef: getRef,
            getRefs: getRefs,
            ref: ref,
            getModelFields: getModelFields,
            getContentRange: getContentRange,
            getVocabularies: getVocabularies,
            loadMenu: loadMenu,
            dispatchAction: dispatchAction,
            attachToScope: attachToScope,
            groupRead: groupRead,
            searchRead: searchRead,
            deleteFromLocalStorage: deleteFromLocalStorage,
            logAction: logAction
        };
        return service;

        /**
         * @ngdoc method
         * @name sortOn
         * @methodOf swif.framework.dataService
         * @param  {Object} params   the filter object
         * @param  {String} key    The field on which one you want to order the records
         * @param  {String} value  'ASC' or 'DESC'
         * @description
         * on which field you want your results to be sorted
         */
        function sortOn(params, key, value) {
            if (!_.isEmpty(key)) {
                if (!_.isEmpty(value)) {
                    params.sort = key + ' ' + value;
                } else {
                    params.sort = key + ' ASC';
                }
                service.setLimit(params);
            }
        }
        /**
         * @ngdoc method
         * @name sortOnRaw
         * @methodOf swif.framework.dataService
         * @param  {Object} params   the filter object
         * @param  {String} sort    The raw sort string
         * @description
         * on which expression you want your results to be sorted
         */
        function sortOnRaw(params, sort) {
            if (!_.isEmpty(sort)) {
                params.sort = sort;
                service.setLimit(params);
            }
        }
        /**
         * @ngdoc method
         * @name getSort
         * @methodOf swif.framework.dataService
         * @param  {Object} params   the filter object
         * @return {Object}
         *
         *    {
         *         key: 'id',
         *         order: 'DESC',
         *         limit: 20,
         *         offset: 0
         *    }
         */
        function getSort(params) {
            var sort = {};
            if (params) {
                if (params.sort) {
                    sort.key = params.sort.split(' ')[0];
                    sort.order = params.sort.split(' ')[1];
                    sort.limit = params.limit;
                    sort.offset = params.offset;
                }
            }
            return sort;
        }
        /**
         * @ngdoc method
         * @name setLimit
         * @methodOf swif.framework.dataService
         * @description
         * Limit the number of records in a request's params
         * @param {Object} params   the filter object
         * @param {number} limit    how many results you want. (20 by default)
         * @param {number} offset   starting point of the results (0 by default)
         */
        function setLimit(params, limit, offset) {
            if (limit !== undefined) {
                params.limit = limit;
            } else if (params.limit === undefined) {
                params.limit = 20;
            }
            if (offset !== undefined) {
                params.offset = offset;
            } else {
                params.offset = 0;
            }
        }

        /**
         * @ngdoc method
         * @name addFilter
         * @methodOf swif.framework.dataService
         * @description
         * addFilter let you push some filters in params.domains array
         * @param {Object} params      the filter object
         * @param {String} field       can be '|' or '&' or a field id
         * @param {String} operator    can be 'in', 'not in', ...
         * @param {String/Bool} value  the filter value
         */
        function addFilter(params, field, operator, value) {
            if (params === undefined) {
                return;
            }
            if (params.domain === undefined) {
                params.domain = [];
            }
            if (operator === undefined && value === undefined) {
                params.domain.push(field); // support & and |
            } else {
                params.domain.push([field, operator, value]);
            }
        }

        /**
         * @ngdoc method
         * @name insertFilter
         * @methodOf swif.framework.dataService
         * @description
         * insertFilter let you inser some a filter in params.domains array
         * @param {Object} params      the filter object
         * @param {String} field       can be '|' or '&' or a field id
         * @param {String} operator    can be 'in', 'not in', ...
         * @param {String/Bool} value  the filter value
         */
        function insertFilter(params, field, operator, value) {
            if (params === undefined) {
                return;
            }
            if (params.domain === undefined) {
                params.domain = [];
            }
            if (operator === undefined && value === undefined) {
                params.domain.splice(0, 0, field); // support & and |
            } else {
                params.domain.splice(0, 0, [field, operator, value]);
            }
        }
        /**
         * @ngdoc method
         * @name addExtraFilter
         * @methodOf swif.framework.dataService
         * @param {Object} params      the filter object
         * @param {String} id          the id of the extra filter so you can get it back later
         * @param {String} field       can be '|' or '&' or a field id
         * @param {String} operator    can be 'in', 'not in', ...
         * @param {String/Bool} value  the filter value
         * @description
         * add an extra filter added to domain in _prepareRequest
         * Theses filters are not visible to the end user
         */
        function addExtraFilter(params, id, field, operator, value) {
            if (params === undefined) {
                return;
            }
            if (params.filters === undefined) {
                params.filters = {};
            }
            if (params.filters[id] === undefined) {
                params.filters[id] = [];
            }
            if (operator === undefined && value === undefined) {
                params.filters[id].push(field); // support & and |
            } else {
                params.filters[id].push([field, operator, value]);
            }
        }

        /**
         * @ngdoc method
         * @name addTextExtraFilter
         * @methodOf swif.framework.dataService
         * @param {Object} params      the filter object
         * @param {String} contentType is the content type on which we getModelFIelds
         * @param {String} value  the filter value
         * @description
         * add an extra text filter on all the the text fields
         * @return {Object} params
         */
        function addTextExtraFilter(params, contentType, value) {
            var valueNumber = parseInt(value, 10);
            var isNumber = !isNaN(valueNumber);
            return service.getModelFields(contentType).then(function(modelFields) {
                var text = {
                    fields: []
                };
                _.forOwn(modelFields, function(field, fieldId) {
                    if ((field.type === 'char' || field.type === 'text')) {
                        if (field.selectable) {
                            text.fields.push(fieldId);
                        }
                    }
                });
                if (isNumber) {
                    service.addExtraFilter(params, 'text', '|');
                    service.addExtraFilter(params, 'text', 'id', '=', valueNumber);
                }
                // It's not a good practice but i haven't found anything else :(
                // Fucking PRH and its equipment reference :|
                if (isNumber && contentType === 'equipment') {
                    service.addExtraFilter(params, 'text', '|');
                    service.addExtraFilter(params, 'text', 'equipment_reference', '=', valueNumber);
                }
                var len = text.fields.length;
                if (len > 1) {
                    for (var i = 0; i < len - 1; i++) {
                        service.addExtraFilter(params, 'text', '|');
                    }
                }
                _.forEach(text.fields, function(field) {
                    var operator = 'ilike';
                    if (value) {
                        service.addExtraFilter(params, 'text', field, operator, value);
                    }
                });
                return params;
            });
        }

        /**
         * @ngdoc method
         * @name mergeExtraFilter
         * @methodOf swif.framework.dataService
         * @param {Object} params      the filter object
         * @description
         * put all extra filters in the domain array and delete extra filters
         */
        function mergeExtraFilter(params) {
            if (params.filters) {
                _.forOwn(params.filters, function(filters) {
                    _.forEach(filters, function(filter) {
                        if (params.domain === undefined) {
                            params.domain = [];
                        }
                        if (_.isArray(filter)) {
                            params.domain.push(filter);
                        } else if (_.isObject(filter)) {
                            service.addFilter(
                                params,
                                filter.field, filter.operator, filter.value
                            );
                        } else if (_.isString(filter)) {
                            service.addFilter(params, filter);
                        } else {
                            msgService.addError({
                                name: 'UnknownTypeError',
                                filter: filter,
                                params: params
                            });
                        }
                    });
                });
                delete params.filters;
            }
        }

        /**
         * @ngdoc method
         * @name resetFilterDomain
         * @methodOf swif.framework.dataService
         * @param {Object} params      the filter object
         * @description
         * set domain array as empty
         */
        function resetFilterDomain(filter) {
            filter.domain = [];
        }

        /**
         * @ngdoc method
         * @name addTextExtraFilter
         * @methodOf swif.framework.dataService
         * @param {Object} params      the filter object
         * @param {String} id optional extra filter id to reset
         * @description
         * remove all extra filter or only one
         */
        function resetExtraFilter(params, id) {
            if (!params) {
                params = {};
            }
            if (!params.filters) {
                params.filters = {};
            }
            if (id) {
                if (!_.isEqual(params.filters[id], [])) {
                    delete params.filters[id];
                }
            } else {
                params.filters = {};
            }
        }

        /**
         * @ngdoc method
         * @name getExtraFilters
         * @methodOf swif.framework.dataService
         * @param {Object} params the filter object
         * @param {String} id the extra filter id
         * @description
         * get extra fitlers
         */

        function getExtraFilters(params, id) {
            if (!params) {
                return;
            }
            if (!params.filters) {
                return;
            }
            var filters = {};
            _.forOwn(params.filters, function(value, key) {
                if ((id && id === key) || !id) {
                    filters[key] = service.getFilters({
                        domain: value
                    });
                }
            });
            return filters;
        }


        /**
         * @ngdoc method
         * @name getFilters
         * @methodOf swif.framework.dataService
         * @param {Object} params the filter object
         * @description
         * get filters as objects {field, operator, value}
         * @return {Array<Object>} filters
         */
        function getFilters(params) {
            var filters = [],
                key = '';
            if (params === undefined) {
                return filters;
            }
            if (params.domain === undefined) {
                return filters;
            }
            _.forEach(params.domain, function(value) {
                if (_.isEmpty(value)) {
                    return;
                }
                if (value.length === 3) {
                    var filter = {
                        field: value[0],
                        operator: value[1],
                        value: value[2]
                    };
                    if (_.contains(settings.DATE_KEYWORDS, filter.value)) {
                        filter.is_relative = true;
                    }
                    // this code break the checkboxes filter (because operator can be = and value can be false)
                    // else if (filter.value === false) {
                    //     filter.operator = filter.operator === '=' ? 'is_not_set' : 'is_set';
                    //     filter.value = undefined;
                    // }
                    filters.push(filter);
                } else {
                    filters.push(value);
                }
            });
            return filters;
        }

        /**
        * @ngdoc method
        * @name deleteFilter
        * @methodOf swif.framework.dataService
        * @description
        * delete part of a filter
        * @param {Object} params given params
        * @param {Object} options {field: 'site1'}
        * @usage
            var filter = $scope.interventions.currentFilter;
            var siteFilter = swif.data.getFilter(filter, {field: 'site1'});
            if (siteFilter) {
                if (siteFilter[2][0] === site.id) {
                    swif.data.deleteFilter(filter, {field: 'site1'});
                } else {
                    siteFilter[2] = [site.id];
                }
            } else {
                swif.data.addFilter(filter, 'site1', 'in', [site.id]);
            }
        **/
        function deleteFilter(params, options) {
            var filter = service.getFilter(params, options);
            if (filter) {
                var index = params.domain.indexOf(filter);
                params.domain.splice(index, 1);
            }
        }

        /**
        * @ngdoc method
        * @name getFilter
        * @methodOf swif.framework.dataService
        * @description
        * get part of the filter
        * @param {Object} params http params object
        * @param {Object} options {field: 'site1'}
        * @returns {String} description
        **/
        function getFilter(params, options) {
            var domains = [];
            var filter;
            if (params) {
                if (params.domain) {
                    domains = params.domain;
                }
            }
            if (options.field) {
                _.forEach(domains, function(domain) {
                    if (_.isArray(domain)) {
                        if (domain[0] === options.field) {
                            filter = domain;
                        }
                    }
                });
            }
            return filter;
        }

        /**
        * @ngdoc method
        * @name setFilters
        * @methodOf swif.framework.dataService
        * @description
        * get part of the filter
        * @param {Object} params http params object
        * @param {Object} filters http params object
        **/
        function setFilters(params, filters) {
            service.resetFilterDomain(params);
            _.forEach(filters, function(filter) {
                if (filter.field) {
                    service.addFilter(
                        params, filter.field, filter.operator, filter.value
                    );
                } else {
                    service.addFilter(params, filter);
                }
            });
        }

        /**
        * @ngdoc method
        * @name encodeQueryParams
        * @methodOf swif.framework.dataService
        * @description
        * encode uri component
        * @param {Object} params http params object
        * @param {Object} filters http params object
        * @return {String} to add to an url
        **/
        function encodeQueryParams(params) {
            var parts = [];
            var key, value, v;
            _.forOwn(params.query, function(value, key) {

                if (value === null || _.isUndefined(value)) {
                    return;
                }
                if (!_.isArray(value)) {
                    value = [value];
                }

                _.forEach(value, function(v) {
                    if (_.isObject(v)) {
                        if (_.isDate(v)) {
                            v = v.toISOString();
                        } else {
                            v = angular.toJson(v);
                        }
                    }
                    parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(v));
                });
            });
            return parts.join('&');
        }

        /**
        * @ngdoc method
        * @name updateObj
        * @methodOf swif.framework.dataService
        * @description
        * update an object with an other keeping the reference.
        * This will not remove any properties from the target
        * @param {Object} source object to get the data from
        * @param {Object} target object to update and keep the reference
        **/
        function updateObj(source, target) {
            if (target !== undefined) {
                _.forOwn(source, function(value, key) {
                    if (target[key] !== value) {
                        target[key] = value;
                    }
                });
            }
        }


        /**
        * @ngdoc method
        * @name updateObj
        * @methodOf swif.framework.dataService
        * @description
        * update an object with an other keeping the reference
        * but removing any property that do not exists in the source
        * Works also with array
        * @param {Object} source object to get the data from.
        * @param {Object} target object to update and keep the reference
        **/
        function replaceObj(a, b) {
            if (_.isArray(a) && _.isArray(b)) {
                while (a.length > 0) {
                    a.pop();
                }
                _.forEach(b, function(value) {
                    a.push(value);
                });
            } else if (_.isObject(a) && _.isObject(b)) {
                _.forOwn(a, function(value, key) {
                    delete a[key];
                });
                _.forOwn(b, function(value, key) {
                    a[key] = value;
                });
            }
        }

        function updateObjFromList(source, target) {
            var found, property;
            _.forEach(source, function(sourceItem) {
                //first try to find it
                found = false;
                _.forOwn(sourceItem, function(value, key) {
                    if (target.id === value) {
                        found = true;
                        service.updateObj(sourceItem, value);
                    }
                });
                if (!found) {
                    target[sourceItem.id] = sourceItem;
                }
            });
        }

        function updateFromList(source, target) {
            //source and target are list
            var found, property;
            _.forEach(source, function(sourceItem) {
                //first try to find it
                found = false;
                _.forEach(target, function(targetItem) {
                    if (targetItem.id === sourceItem.id) {
                        found = true;
                        service.updateObj(sourceItem, targetItem);
                    }
                });
                if (!found) {
                    target.push(sourceItem);
                }
            });
        }

        /**
        * @ngdoc method
        * @name getContentTypeConfig
        * @methodOf swif.framework.dataService
        * @param {String} contentType name of the content type
        * @returns {Object} content type configuration
        **/
        function getContentTypeConfig(contentType) {
            return settings.app.contentTypes[contentType];
        }

        function _getModel(contentType) {
            return service.getContentTypeConfig(contentType).model;
        }

        function _getFilter(contentType) {
            return service.getContentTypeConfig(contentType).filter;
        }

        /**
         * format the request for openerp
         * @param  {Object} httpIn request
         * @return {Object}        request OK to be sent to OpenERP
         */
        function _prepareHTTPRequest(httpIn) {
            var lng_code = settings.get('authenticated_user_data') ? settings.get('authenticated_user_data').context_lang : settings.app.defaultValues.user.context_lang;

            var data = httpIn.params;
            var params;
            requestId += 1;

            if (data === undefined) {
                params = {};
            } else {
                params = angular.copy(data);
            }

            service.mergeExtraFilter(params);
            var http = {
                jsonrpc: '2.0',
                method: 'call',
                params: params,
                id: 'r' + requestId
            };
            params.session_id = settings.get('token');
            var uid = null;
            if (settings.get('authenticated_user') !== undefined) {
                uid = settings.get('authenticated_user').uid;
            }
            var defaultContext = {
                '__ref': 'compound_context',
                '__contexts': [{
                    lang: lng_code,
                    tz: 'Europe/Paris',
                    uid: uid
                }, {
                    'bin_size': true
                }],
                '__eval_context': null
            };
            if (params.context) {
                defaultContext.__contexts.push(params.context);
            }
            params.context = defaultContext;

            return http;
        }

        function completeServerUrl(http) {
            var url = http.url;
            var odooServer = settings.app['odoo-server'];
            if (odooServer) {
                // ensure the odoo url is relative to the current host,
                // cannot call to a distant server without 'CORS' settings
                if (odooServer[0] !== '/') {
                    odooServer = '/' + odooServer;
                    // will fail if odooServer contains http* protocol
                }
                url = odooServer + url;
            }
            return url;
        }

        /**
        * @ngdoc method
        * @name post
        * @methodOf swif.framework.dataService
        * @param {String} contentType name of the content type
        * @param {Object} http the request data to send
        * @param {Boolean} displayError optional boolean to control display of errors
        * (true by default)
        * @returns {Promise} of the response
        **/
        function post(contentType, http, displayError) {
            //maybe one day, we should use angular http interceptors for all this stuff
            var deferred = $q.defer();
            if (displayError === undefined) {
                displayError = true;
            }
            var onError = function(error) {
                msgService.stopRequest();
                var rejected = false;
                if (error.data) {
                    if (error.data.type === 'session_invalid') {
                        rejected = true;
                        if (!$location.search().next) {
                            $location.search('next', $location.path());
                        }
                        $location.path('/logout');
                        msgService.addInfo('Session invalid');
                        console.log('session invalid');
                        deferred.resolve(error);
                    }
                }
                if (!rejected) {
                    error.swif = {
                        type: 'OpenERP',
                        content_type: contentType,
                        http: http
                    };
                    if (displayError) {
                        msgService.addError(error);
                    }
                    deferred.reject(error);
                }
            };
            var request = service._prepareHTTPRequest(http);
            msgService.startRequest();
            var url = completeServerUrl(http);
            var responseValue = CacheService.get(http);
            if(responseValue!=undefined){
                deferred.resolve(responseValue);
            }else{
                if(http.url==='/web/dataset/save'){
                    // we have to delete the old values in the cache
                    CacheService.deleteContentTypeValues(http.params.model);
                }
                $http.post(url, request).then(function(data) {
                    msgService.stopRequest();
                    CacheService.put(data.config, data.data.result);
                    if (data.data.error !== undefined) {
                        onError(data.data.error);
                    } else {
                        deferred.resolve(data.data.result);
                    }
                }, onError);
            }
            return deferred.promise;
        }


        /**
         * @ngdoc method
         * @name prepareOne2manyValues
         * @methodOf swif.framework.dataService
         * @param {Array or Ids} fieldValue value of the o2m field (as returned by get())
         * @param {Array} newValues of Objects to be prepared for save()
         * @param {function} customSanitizeFnct callable to sanitize items

         * 1st param is the item to sanitize, must returns the new object value
         * @return {Array} sanitized values usable in save() / create()
         * to handle creation, update and deletion in only one transaction
         * reminder:
         *  ```
         *  [0, 0, {}] => create ONE item
         *  [1, ID, {}] => update ONE existing item
         *  [2, ID] => remove ONE existing item
         *  ```
         *  all these Arrays are inserted in a global Array
         *  (you can chain them as long as you want)
         */
        function prepareOne2manyValues(fieldValue, newValues, customSanitizeFnct) {
            var ret = [];
            var idsToUpdate = [];
            _.forEach(newValues, function(item) {
                // manually sanitize the item object (faster)
                // and check if service is a creation or an update (per item)
                var newItem = item;
                if (customSanitizeFnct) {
                    newItem = customSanitizeFnct(item);
                }
                if (item.id) {
                    idsToUpdate.push(item.id);
                    ret.push([1, item.id, newItem]);
                } else {
                    ret.push([0, 0, newItem]);
                }
            });

            // finally, remove the items not present anymore
            // to do service, i compare the initial value and the new one
            var uniqueValues = _.xor(fieldValue, idsToUpdate);
            //([2, 1], [4, 2]) → [1, 4]
            var removed_ids = _.intersection(fieldValue, uniqueValues);
            //([2, 1], [1,4]) → [1]
            _.forEach(removed_ids, function(remove_id) {
                ret.push([2, remove_id]);
            });
            return ret;
        }

        /**
         * @ngdoc method
         * @name prepareImport
         * @methodOf swif.framework.dataService
         * @param {Array} input ?
         * @param {Array} fields ?
         * @return {Array<Array<value/false>>} data for import route
         */

        function prepareImport(input, fields) {
            var data = [];
            _.forEach(input, function(o) {
                var list = [];
                _.forEach(fields, function(field) {
                    list.push(o[field] ? o[field] : false);
                });
                data.push(list);
            });
            return data;
        }

        /**
        * @ngdoc method
        * @name sanitizeData
        * @methodOf swif.framework.dataService
        * @description
        * method to sanitize the data before send it to the server
        * @param {string} contentType content type
        * @param {Object} data data to sanitize
        * @param {Array<String>} fields optional list of fields to sanitize
        * @returns {Promise<Object>} the data sanitized
        **/
        function sanitizeData(contentType, data, fields) {
            var deferred = $q.defer();
            var copy = angular.copy(data);
            if (contentType === undefined) {
                deferred.resolve(copy);
            } else {
                if (fields !== undefined) {
                    //remove unwanted fields (from fields params)
                    _.forOwn(copy, function(value, key) {
                        if (!_.contains(fields, key)) {
                            delete copy[key];
                        }
                    });
                } else {
                    _.forEach([
                        'write_uid', 'create_uid', 'id',
                        'actions', 'create_date', 'write_date'
                    ], function(key) {
                        if (copy[key] !== undefined) {
                            delete copy[key];
                        }
                    });
                }
                //if not loggedin -> resolve
                if (!settings.get('token')) {
                    deferred.resolve(copy);
                    return deferred.promise;
                }
                service.getModelFields(contentType).then(function(mfields) {
                    if (fields === undefined) {
                        //remove unwanted fields
                        _.forOwn(copy, function(value, key) {
                            if (!_.has(mfields, key)) {
                                delete copy[key];
                            }
                        });
                        //remove not stored field
                        _.forOwn(mfields, function(field, key) {
                            if (field.function && field.readonly) {
                                delete copy[key];
                            }
                        });
                    }
                    //transform relation data to keep only ids
                    _.forOwn(copy, function(value, key) {
                        if (_.has(mfields, key)) {
                            switch (mfields[key].type) {
                                case 'many2one':
                                    if (copy[key]) {
                                        copy[key] = copy[key][0];
                                    }
                                    break;
                                case 'many2many':
                                    if (value) {
                                        copy[key] = [
                                            [6, 0, value]
                                        ];
                                    } else {
                                        copy[key] = [
                                            [6, 0, []]
                                        ];
                                    }
                                    break;
                                    /* TODO:
                                      for now, we only handle values being array of arrays:
                                        - */
                                case 'one2many':
                                    if (value && _.isArray(value) &&
                                        value.length > 0 && _.isArray(value[0])) {
                                        copy[key] = value;
                                    } else {
                                        delete copy[key];
                                    }
                                    break;
                                case 'date':
                                    if (copy[key]) {
                                        let dateVal = moment.utc(copy[key]);
                                        copy[key] = dateVal.format('YYYY-MM-DD');
                                    }
                                    break;
                                case 'datetime':
                                    if (copy[key]) {
                                        let datetimeVal = moment.utc(copy[key]);
                                        copy[key] = datetimeVal.format('YYYY-MM-DD HH:mm:ss');
                                    }
                                    break;
                                case 'selection':
                                    if (copy[key]) {
                                        if (_.isArray(copy[key])) {
                                            copy[key] = copy[key][0];
                                        }
                                    }
                                    break;
                                case 'geo_point':
                                    if (copy[key]) {
                                        let point = JSON.parse(copy[key]);
                                        copy[key] = `Point(${point.coordinates[0]} ${point.coordinates[1]})`;
                                    }
                                    break;
                            }
                        }
                    });
                    deferred.resolve(copy);
                }, function(error) {
                    deferred.reject(error);
                });
            }
            return deferred.promise;
        }

        function _prepareCollectionItems(records, contentType) {
            _.map(records, function(item) {
                item._type = contentType;
                return item;
            });
        }

        function _get(contentType, id, params, displayError) {
            var self = service;
            var deferred = $q.defer();
            if (!settings.get('token') || !settings.app.initialized) {
                deferred.reject();
                return deferred.promise;
            }
            var http = {
                params: {}
            };
            if (params) {
                http.params = params;
            }
            http.params.model = service.getModel(contentType);
            http.fields = service.getFields(contentType);
            if (!http.params.fields) {
                http.params.fields = http.fields;
            }
            if (id === undefined || id === null) {
                http.url = '/web/dataset/search_read';
                var filter = service._getFilter(contentType);
                if (filter) {
                    if (!http.params.filters) {
                        http.params.filters = {};
                    }
                    http.params.filters.__default__ = filter;
                }
            } else {
                http.url = '/web/dataset/get';
                if (_.isArray(id)) {
                    http.params.ids = id;
                } else {
                    http.params.ids = [parseInt(id, 10)];
                }
            }
            service.post(contentType, http, displayError).then(function(data) {
                var records = data;
                if (!id) {
                    records = data.records;
                }
                self._prepareCollectionItems(records, contentType);
                deferred.resolve(data);
            }, function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        /**
        * @ngdoc method
        * @name get
        * @methodOf swif.framework.dataService
        * @description
        * get an object by id
        * @param {String} contentType name of the content type
        * @param {String or Number} id id of the content to get
        * @param {Object} params http specific params {fields: ['name', ...]}
        * @param {Boolean} displayError set to false to not display error to the user
        * @returns {Promise} with the object you wanna get
        **/
        function get(contentType, id, params, displayError) {
            var deferred = $q.defer();
            service._get(contentType, id, params, displayError)
                .then(function(data) {
                    if (id === undefined || id === null) {
                        deferred.resolve(data.records);
                    } else {
                        if (data.length === 1) {
                            deferred.resolve(data[0]);
                        } else {
                            console.log('weird');
                            deferred.resolve(data);
                        }
                    }
                }, function(error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }


        /**
        * @ngdoc method
        * @name call
        * @methodOf swif.framework.dataService
        * @description
        * call a remote function /web/dataset/call
        * @param {String} contentType name of the content type
        * @param {String} method name of the method to call
        * @param {Array} args optional args to send to the remote function
        * @param {Object} domain_id ?
        * @param {Object} context_id ?
        * @returns {Promise} with the response
        **/
        function call(contentType, method, args, domain_id, context_id) {
            var http = {
                url: '/web/dataset/call',
                params: {}
            };
            http.params.model = service._getModel(contentType);
            http.params.method = method;
            http.params.args = args;
            http.params.domain_id = domain_id;
            http.params.context_id = context_id;
            return service.post(contentType, http);
        }

        /**
        * @ngdoc method
        * @name callKw
        * @methodOf swif.framework.dataService
        * @description
        * call a remote function /web/dataset/callkw
            call_kw is the most efficient method to call any available methods
            in the Odoo ORM, it allows to pass the requred params AND the
        * @param {String} contentType name of the content type
        * @param {String} method name of the method to call
        * @param {Array} args optional args to send to the remote function
        * @param {Object} kwargs Object (named optionals params on the method)
        * @param {Boolean} isCollection Boolean, default to false (if true, prepare the items such as _get() method does)
        * @param {Boolean} displayError Boolean, default to true, display or not error modal
        * @returns {Promise} with the response
        */
        function callKw(contentType, method, args, kwargs, isCollection, displayError) {
            var http = {
                url: '/web/dataset/call_kw',
                params: {}
            };
            http.params.model = service.getModel(contentType);
            http.params.method = method;
            http.params.args = args || [];
            http.params.kwargs = kwargs || {};
            return service.post(contentType, http, displayError).then(function(data) {
                if (isCollection) {
                    service._prepareCollectionItems(data, contentType);
                }
                return data;
            });
        }


        /**
        * @ngdoc method
        * @name execWorkflow
        * @methodOf swif.framework.dataService
        * @description
        * call the remote /web/dataset/exec_workflow
        * @param {String} contentType name of the content type
        * @param {String} id name of the method to call
        * @param {String} signal signal to send to trigger a transition
        * @returns {Promise} with the response
        */
        function execWorkflow(contentType, id, signal) {
            var httpConfig = {
                url: '/web/dataset/exec_workflow'
            };
            httpConfig.params = {
                model: service._getModel(contentType),
                id: id,
                signal: signal
            };
            return service.post(contentType, httpConfig);
        }

        /**
        * @ngdoc method
        * @name create
        * @methodOf swif.framework.dataService
        * @description
        * call the remote /web/dataset/exec_workflow
        * @param {String} contentType name of the content type
        * @param {Object} data data to let the server create the new instance
        * @param {Array<String>} fields fields list of the fields model
        * @param {Object} context optional context
        * @returns {Promise} with the response
        * Dont forget to get the id of the new object in the response
        */
        function create(contentType, data, context, fields) {
            var httpConfig = {
                url: '/web/dataset/create'
            };
            return service.sanitizeData(contentType, data, fields)
                .then(function(sdata) {
                    httpConfig.params = {
                        model: service._getModel(contentType),
                        data: sdata
                    };
                    if (context) {
                        httpConfig.params.context = context;
                    }
                    return service.post(contentType, httpConfig);
                });
        }

        /**
        * @ngdoc method
        * @name save
        * @methodOf swif.framework.dataService
        * @description
        * call the remote /web/dataset/exec_workflow
        * @param {String} contentType name of the content type
        * @param {String} id of the object to save
        * @param {Object} data data to let the server create the new instance
        * @param {Object} context optional context
        * @returns {Promise} with the response
        */
        function save(contentType, id, data, context) {
            //externaliser cette variable
            var httpConfig = {
                url: '/web/dataset/save'
            };
            return service.sanitizeData(contentType, data)
                .then(function(sdata) {
                    httpConfig.params = {
                        model: service._getModel(contentType),
                        id: id,
                        data: sdata
                    };
                    if (context) {
                        httpConfig.params.context = context;
                    }
                    return service.post(contentType, httpConfig);
                });
        }

        /**
        * @ngdoc method
        * @name unlink
        * @methodOf swif.framework.dataService
        * @description
        * delete the object using /web/dataset/unlink
        * @param {String} contentType name of the content type
        * @param {Array or String} ids one or many ids to delete
        * @returns {Promise} with the response
        */
        function unlink(contentType, ids) {
            var httpConfig = {
                url: '/web/dataset/unlink'
            };
            httpConfig.params = {
                model: service._getModel(contentType),
                ids: _.isArray(ids) ? ids : [ids]
            };
            if (_.isEmpty(ids)){
                return $q.when();
            }else {
                return service.post(contentType, httpConfig);
            }
        }

        /**
        *
        * @DEPRECATED???
        *
        * @ngdoc method
        * @name exportCsv
        * @methodOf swif.framework.dataService
        * @description
        * export using /web/export/csv route
        * @param {String} contentType name of the content type
        * @param {Array or String} ids one or many ids to download
        * @param {Array} fields list of fields you wanna gets
        * @param {Array} the domain you want to filter the export
        * @returns {Promise} with the response
        */
        function exportCsv(contentType, ids, fields, domain) {
            var httpConfig = {
                url: '/web/export/csv'
            };
            httpConfig.params = {
                model: service._getModel(contentType),
                ids: _.isArray(ids) ? ids : [ids],
                fields: fields,
                domain: domain ? domain : [],
                import_compat: false
            };
            return service.post(contentType, httpConfig);
        }

        function _exportCSV(contentType, fields, ids, filename, kwargs) {
            var deferred = $q.defer();
            var params = Object.assign({}, {fields: fields}, kwargs)

            service.callKw(contentType, 'build_csv_rows', ids, params).then(function (data) {
                var blob = new Blob([
                    new Uint8Array([0xEF, 0xBB, 0xBF]),
                    data
                ], {type: 'octet/stream;charset=utf-8'});

                if (filename === undefined || !filename) {
                    var modelName = settingsService.getContentType(contentType).title;
                    filename = 'opengst-' + modelName;
                }

                saveAs(blob, filename + '.csv');
                deferred.resolve();
            });
            return deferred.promise;
        }

        function _computeSaveAsPOST(contentType, field, id, filename_field, context) {
            var httpConfig = {
                url: '/web/binary/saveas_ajax'
            };
            var data = {
                model: service._getModel(contentType),
                id: id || false,
                field: field,
                filename_field: filename_field || false,
                context: context || {}
            };
            httpConfig.data = JSON.stringify(data);
            var now = moment();
            httpConfig.token = now.unix() * 1000 + now.milliseconds();
            httpConfig.session_id = settings.get('token');
            return httpConfig;
        }

        /**
        * @ngdoc method
        * @name saveAs
        * @methodOf swif.framework.dataService
        * @description
        * download a file
        * @param {String} contentType name of the content type
        * @param {Array} fields list of fields you wanna gets
        * @param {String} id the id you want to save
        * @param {String} filename_field the name of hte field where the file is
        * @param {Object} context optional context
        * @returns {Promise} with the response
        */
        function _saveAs(contentType, field, id, filename_field, context) {
            var config = service._computeReportPOST(contentType, field, id, filename_field, context);
            return service.post(contentType, config);
        }

        function _computeReportPOST(action) {
            var httpConfig = {};
            var params = {
                url: '/web/report'
            };
            params.action = JSON.stringify(action);
            var now = moment();
            params.token = now.unix() * 1000 + now.milliseconds();
            params.session_id = settings.get('token');
            return params;
        }


        /**
        * @ngdoc method
        * @name downloadReport
        * @methodOf swif.framework.dataService
        * @description
        * download a file

        - retrieve the related ir.actions.report.xml according to report_name

        - call /web/report with action = ir.actions.report.xml data retrieved

        - the server will return the file with contentType = attachment  and filename = report_name

        * @param {String} contentType name of the content type
        * @param {String} reportName name of the report to print (without the prefix 'report.')
        * @param {Array or String} ids list of ids (or integer id) of records to print
        * @param {Object} obj Object where the POST definition will be stored under 'printParams' key
        * @param {Object} context optional context
        * @returns {Promise} with the response
        */
        function downloadReport(contentType, reportName, ids, obj, ctx) {
            // As authorized values of ids can be Array or Integer,
            // I force the ids to be an Array.
            // if ids is Null, 0, Empty Array, etc. stop here
            var lng_code = settings.get('authenticated_user_data') ? settings.get('authenticated_user_data').context_lang : settings.app.defaultValues.user.context_lang;

            var rids = [];
            if (ids) {
                rids = _.isArray(ids) ? ids : [ids];
            }
            if (rids.length > 0) {
                var uid = null;
                if (settings.get('authenticated_user') !== undefined) {
                    uid = settings.get('authenticated_user').uid;
                }
                // compute the user context + the selected-records context
                var context = {
                    active_model: service._getModel(contentType),
                    active_ids: rids,
                    active_id: rids[0],
                    lang: lng_code,
                    tz: 'Europe/Paris',
                    uid: uid
                };
                if (ctx) {
                    _.merge(context, ctx);
                }
                var filter = {
                    domain: [
                        ['report_name', '=', reportName]
                    ]
                };
                return service.get('report_actions', undefined, filter)
                    .then(function(data) {
                        var action = data ? data[0] : {};
                        action.context = context;
                        obj.printParams = service._computeReportPOST(action);
                        return obj;
                    });
            } else {
                return $q(function(resolve, reject) {
                    reject("No id provided to print");
                });
            }
        }

        /**
        * @ngdoc method
        * @name getModel
        * @methodOf swif.framework.dataService
        * @description return the model name from the content type name
        * @param {String} contentType name of the content type
        * @returns {String} model name
        */
        function getModel(contentType) {
            return settings.getContentType(contentType).model;
        }

        /**
        * @ngdoc method
        * @name getFields
        * @methodOf swif.framework.dataService
        * @description return the list of fields to get by default
        * @param {String} contentType name of the content type
        * @returns {Array} of fields name to get by default
        */
        function getFields(contentType) {
            var config = settings.getContentType(contentType);
            var fields = angular.copy(config.fields);
            if (fields) {
                for (let pp in config.moduleFields) {
                    if (swifModule.modules[pp]) {
                        fields = fields.concat(config.moduleFields[pp]);
                    }
                }
            }
            return fields;
        }


        /**
        * @ngdoc method
        * @name getRef
        * @methodOf swif.framework.dataService
        * @description return the complete reference from the ir_model_data table
        * @param {String} module_dot_xml_id the corresponding xml reference
        * @returns {Promise} with the ref
        */
        function getRef(module_dot_xml_id) {
            // TODO : return from cache if possible
            if (service.XML_IDS[module_dot_xml_id]) {
                return $q.when(service.XML_IDS[module_dot_xml_id]);
            }
            var module_str = module_dot_xml_id.split('.')[0];
            var xml_id = module_dot_xml_id.split('.')[1];
            var filter = {};
            service.addFilter(filter, 'name', '=', xml_id);
            service.addFilter(filter, 'module', '=', module_str);
            return service.searchRead('ir_model_data', filter).then(function(data) {
                if (data) {
                    if (_.size(data.records) === 1) {
                        service.XML_IDS[module_dot_xml_id] = data.records[0];
                        return data.records[0];
                    }
                }
            });
        }

        /**
        * @ngdoc method
        * @name getRefs
        * @methodOf swif.framework.dataService
        * @description same as getRef but with an array
        * @param {Array<String>} module_dot_xml_ids the corresponding xml references
        * @returns {Promise} with the references
        */
        function getRefs(module_dot_xml_ids) {
            return $q.all(module_dot_xml_ids.map((xml_id) => ref(xml_id)));
        }

        /**
        * @ngdoc method
        * @name getRefs
        * @methodOf swif.framework.dataService
        * @description ref() as openerp function
        * @param {String} module_dot_xml_id the corresponding xml reference
        * @returns {Promise} with the reference id
        */
        function ref(module_dot_xml_id) {
            return service.getRef(module_dot_xml_id).then(function(ref) {
                if (ref) {
                    return ref.res_id;
                }
            });
        }

        /**
        * @ngdoc method
        * @name getModelFields
        * @methodOf swif.framework.dataService
        * @description Retrieve a dictionary describing the model.
        * Each entry of the dictionary is itself a dictionary describing the field
        * @param {String} contentType name identifying the model for which to retrieve the fields
        * @returns {Promise} with the model fields
        * ```
        * {
        *     field: {type: 'char', selectable: false, ...},
        *     field: {type: 'number', selectable: false, ...},
        *     ...
        * }
        * ```
        */
        function getModelFields(contentType) {
            // here we could use the cache service, but there is too many request to declare (around 96)...
            var deferred = $q.defer();
            if (!cache.modelfields) {
                cache.modelfields = {};
            }
            if (cache.modelfields[contentType]) {
                deferred.resolve(cache.modelfields[contentType]);
            } else {
                var http = {
                    url: '/web/searchview/fields_get',
                    params: {
                        model: service.getModel(contentType)
                    }
                };
                service.post(contentType, http).then(function(data) {
                    cache.modelfields[contentType] = data.fields;
                    deferred.resolve(data.fields);
                }, function(error) {
                    deferred.reject(error);
                });
            }
            return deferred.promise;
        }

        /**
        * @ngdoc method
        * @name getContentRange
        * @methodOf swif.framework.dataService
        * @description return the number of results you should have for a given filter
        * @param {String} contentType name of the content type
        * @param {Object} params filter
        * @returns {Promise} with the the count
        */
        function getContentRange(contentType, params) {
            var domain = [];
            if (params) {
                params = angular.copy(params);
                service.mergeExtraFilter(params);
                if (!_.isEmpty(params.domain)) {
                    domain = params.domain;
                }
            }
            return service.callKw(contentType, 'search', [domain], {
                count: true
            });
        }

        function getVocabularies(params) {
            var contentTypes = _.keys(params);
            var self = service;
            var promises = [];
            _.forOwn(params, function(value, key, obj) {
                var query = {
                    'fields': ['id', 'name', 'complete_name']
                };
                var ct = key;
                if (value === true) {
                    promises.push(self.get(ct, undefined, query));
                } else if (typeof value === 'object') {
                    var q = angular.copy(query);
                    q.domain = value.domain;
                    promises.push(self.get(ct, undefined, q));
                }
            });
            return $q.all(promises).then(function(listVocab) {
                var vocabularies = {};
                for (var i = 0; i < contentTypes.length; i++) {
                    var ct = contentTypes[i];
                    vocabularies[ct] = listVocab[i];
                }
                return vocabularies;
            });
        }

        function loadMenu() {
            if (settings.get('authenticated_user') === undefined) {
                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
            }
            var http = {
                method: 'POST',
                url: '/web/dataset/call',
                params: {
                    args: [],
                    model: 'res.users',
                    method: 'get_menu_formatted'
                }
            };
            return service.post(undefined, http).then(function(data) {
                if (data) {
                    settings.set('menu', data);
                    return data;
                }
            });
        }

        /**
        * @ngdoc method
        * @name dispatchAction
        * @methodOf swif.framework.dataService
        * @description send you action to the server
        * @param {String} contentType name of the content type
        * @param {Object} action action object got from actionService
        * @param {Object} data data to send
        * @returns {Promise} with the response
        */
        function dispatchAction(contentType, action, data) {
            var promise;
            var self = service;
            var httpConfig = angular.copy(action.http);
            if (!_.isUndefined(data)) {
                switch (httpConfig.url) {
                    case '/web/dataset/create':
                        return self.sanitizeData(contentType, data, action.http.fields)
                            .then(function(sdata) {
                                httpConfig.params = {
                                    data: sdata,
                                    model: self._getModel(contentType)
                                };
                                return self.post(contentType, httpConfig);
                            });
                    case '/web/dataset/save':
                        return self.sanitizeData(contentType, data, action.http.fields)
                            .then(function(sdata) {
                                httpConfig.params = {
                                    data: sdata,
                                    model: self._getModel(contentType),
                                    id: data.id
                                };
                                return self.post(contentType, httpConfig);
                            });
                    case '/web/dataset/unlink':
                        httpConfig.params = {
                            model: self._getModel(contentType)
                        };
                        if (data.id) {
                            httpConfig.params.ids = [data.id];
                        } else if (data.ids) {
                            httpConfig.params.ids = data.ids;
                        }
                        return self.post(contentType, httpConfig);
                    case '/web/dataset/search_read':
                        var params = data;
                        return self.get(contentType, undefined, params);
                    case '/web/dataset/exec_workflow':
                        httpConfig.params = {
                            model: self._getModel(contentType),
                            id: data.id,
                            signal: action.workflow.signal
                        };
                        return self.post(contentType, httpConfig);
                    case '/web/dataset/call_kw':
                        return self.callKw(contentType, action.http.method, data.args, data.kwargs);
                    case '/web/session/change_password':
                        httpConfig.params = {
                            fields: [{
                                name: 'old_pwd',
                                value: data.old_pwd
                            }, {
                                name: 'new_password',
                                value: data.new_password
                            }, {
                                name: 'confirm_pwd',
                                value: data.confirm_pwd
                            }]
                        };
                        return self.post(contentType, httpConfig);
                    case '/localstorage/create':
                        return self.localStorage(contentType, {
                            data: data
                        });
                    case '/localstorage/save':
                        return self.localStorage(contentType, {
                            data: data
                        });
                    case '/localstorage/delete':
                        return self.deleteFromLocalStorage(contentType, data.id);
                    case '/web/export/csv':
                        var tmp = action.http.data;
                        return self.exportCsv(
                            contentType, tmp.ids, tmp.fields, tmp.domain
                        );
                    default:
                        httpConfig.params = data;
                        return self.post(contentType, httpConfig);
                }
            }
        }

        function attachToScope(scope, propertyId, contentType, id, params) {
            return service.get(contentType, id, params).then(
                function(data) {
                    scope[propertyId] = data;
                    return data;
                }
            );
        }

        /**
        * @ngdoc method
        * @name groupRead
        * @methodOf swif.framework.dataService
        * @description send a /web/group/read
        * @param {String} contentType name of the content type
        * @param {Object} params http params
        * @param {Object} group_by_fields don t forget to include those fields in the params
        * @returns {Promise} with the response
        */
        function groupRead(contentType, params, group_by_fields) {
            //(req, model, fields, group_by_fields, domain=None, sort=None)
            var http = {
                url: '/web/group/read',
                params: {}
            };
            http.params = angular.copy(params);
            delete http.params.offset;
            delete http.params.limit;
            http.params.model = service.getModel(contentType);
            http.params.fields = params.fields || _.union(['id', 'name'], group_by_fields);
            http.params.group_by_fields = group_by_fields;
            return service.post(contentType, http);
        }


        /**
        * @ngdoc method
        * @name searchRead
        * @methodOf swif.framework.dataService
        * @description send a /web/dataset/search_read to get the search results (not only ids)
        * @param {String} contentType name of the content type
        * @param {Object} params http params
        * @returns {Promise} with the response
        */
        function searchRead(contentType, params) {
            var http = {
                url: '/web/dataset/search_read',
                params: params
            };
            if (!params) {
                http.params = {};
            }
            var filter = service._getFilter(contentType);
            if (filter) {
                if (!http.params.filters) {
                    http.params.filters = {};
                }
                http.params.filters.__default__ = filter;
            }
            http.params.model = service.getModel(contentType);
            http.fields = service.getFields(contentType);
            if (!http.params.fields) {
                http.params.fields = http.fields;
            }
            return service.post(contentType, http).then(function(response) {
                _.map(response.records, function(item) {
                    item._type = contentType;
                    return item;
                });
                return response;
            });
        }

        function localStorage(contentType, params) {
            var deferred = $q.defer();
            var def = {};
            def[contentType] = {
                nextId: 0
            };
            var storage = $localStorage.$default(def);
            if (params.data.id === undefined) {
                //update nextId
                _.forOwn(storage[contentType], function(v, k) {
                    if (k === 'nextId') {
                        return;
                    }
                    if (storage[contentType].nextId <= v.id) {
                        storage[contentType].nextId = v.id + 1;
                    }
                });
                params.data.id = storage[contentType].nextId;
                storage[contentType].nextId += 1;
            }
            params.data._type = contentType;
            storage[contentType][params.data.id] = params.data;
            deferred.resolve(storage[contentType][params.data.id]);
            return deferred.promise;
        }

        function deleteFromLocalStorage(contentType, id) {
            var deferred = $q.defer();
            delete $localStorage[contentType][id];
            deferred.resolve(id);
            return deferred.promise;
        }

        function logAction(data) {
            var message = '' + data.action.id + ' id:' + data.model.id;
            return service.create('log', {
                message: message
            });
        }
    }

})();
